import { Component, Input } from '@angular/core';

enum iconSize {
  extraSmall,
  small,
  regular
}

@Component({
  selector: 'app-medical-notes-icon',
  templateUrl: './medical-notes-icon.component.html',
  styleUrls: ['./medical-notes-icon.component.css']
})
export class MedicalNotesIconComponent {

  @Input() size: iconSize = iconSize.regular;

  iconSize = iconSize;

  constructor() {}

}
